/**
 * Strategy tab sub-views. The active one lives in the URL (`?tab=`) so it
 * deep-links and survives a reload. Go/No-Go is first in the control, but the
 * landing view when `?tab=` is absent stays Win Themes — today's default.
 */
export type StrategyTab = 'go-no-go' | 'win-themes' | 'bid-brief'

export const STRATEGY_TABS: { value: StrategyTab; label: string }[] = [
  { value: 'go-no-go', label: 'Go/No-Go' },
  { value: 'win-themes', label: 'Win Themes' },
  { value: 'bid-brief', label: 'Bid Brief' },
]

export const DEFAULT_STRATEGY_TAB: StrategyTab = 'win-themes'

export const STRATEGY_TAB_PARAM = 'tab'

const STRATEGY_TAB_VALUES = new Set<string>(STRATEGY_TABS.map((t) => t.value))

/** Unknown or missing values fall back to the default rather than a blank view. */
export function parseStrategyTab(value: string | null): StrategyTab {
  return value != null && STRATEGY_TAB_VALUES.has(value)
    ? (value as StrategyTab)
    : DEFAULT_STRATEGY_TAB
}

/**
 * Where a Strategy sub-view lives since R4: Go/no-go is on Qualify, Win
 * themes and the Bid Brief are on Plan.
 */
export function strategyTabPath(bidId: string, tab: StrategyTab): string {
  if (tab === 'go-no-go') return `/app/bids/${bidId}/qualify?view=go-no-go`
  return `/app/bids/${bidId}/plan?view=${tab === 'bid-brief' ? 'brief' : 'win-themes'}`
}
